<template>
  <div class="divServe">
    <el-card class="getSeverMsg">
      <el-form :model="params" :rules="rules" ref="ruleForm">
        <el-form-item label="公司名称" prop="companyName">
          <el-input type="text" v-model="params.companyName"></el-input>
        </el-form-item>
        <el-form-item label="服务器名称" prop="name">
          <el-input type="text" v-model="params.name"></el-input>
        </el-form-item>
        <el-form-item label="内网ip" prop="privateIP">
          <el-input type="text" v-model="params.privateIP"></el-input>
        </el-form-item>
        <el-form-item label="公网ip">
          <el-input type="text" v-model="params.publicIP"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input type="text" v-model="params.userName"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="text" v-model="params.password"></el-input>
        </el-form-item>
        <el-form-item label="服务器配置">
          <el-input type="textarea" v-model="params.configuration"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="params.remark"></el-input>
        </el-form-item>
        <button class="btn_bind" @click.prevent="save" style="width: 100%;">保存配置</button>
      </el-form>
    </el-card>
  </div>

</template>

<script>
  import { getServeMsg,saveServeMsg } from '@/api'
  const isChinese = (rule, value, callback) => {
      const age= /[\u4E00-\u9FA5]/g
      if (!age.test(value)) {
       callback()
      }else{
         callback(new Error('不允许输入汉字'))
      }
    }
  export default {
    data() {
      return {
        params: {},
        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
          ],
          privateIP: [
            { required: true, message: '请输入私网ip', trigger: 'blur' },
          ],
          publicIP: [
            { required: true, message: '请输入公网ip', trigger: 'blur' },
          ],
          companyName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          userName: [
            { required: true, message: '请输入用户名称', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { validator: isChinese, trigger: 'blur' }
          ],
        }
      }
    },

    mounted() {
      this.getMsg(this.$route.query.id)
    },
    methods: {
      getMsg(id) {
        getServeMsg(id).then(res => {
          if (res.data) {
            this.params = res.data
          }

        })
      },
      save() {
        this.params.id = this.$route.query.id
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            saveServeMsg(this.params).then(res=>{
              this.$toast('保存成功')
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });

      }
    }
  }
</script>

<style>
  .divServe{
    padding: 2%;
  }
  .getSeverMsg{
    background: #ffff;
    width: 100%;
  }
  .lable{
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 5px;
    font-size: 16px;
  }
</style>





// WEBPACK FOOTER //
// src/view/xxcx/getSeverMsg.vue